import React, { useEffect, useState } from 'react';
import ApiClient from '../../Services/ApiClient';
import { useAlert } from '../ui/alertProvider';
import { useResources } from '../../store/resourcesProvider';

const PatientDashboard: React.FC = () => {
    const [meetings, setMeetings] = useState<any[]>([]);
    const [payments, setPayments] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const alert = useAlert();
    const resources = useResources();

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        setLoading(true);
        try {
            const data: any = await ApiClient.get('/meetings/me');
            setMeetings((data && data.items) || []);
            try {
                const payData: any = await ApiClient.get('/payments/me');
                // payData is expected to be an array of payments
                setPayments(Array.isArray(payData) ? payData : (payData?.items ?? []));
            } catch (pe) {
                console.warn('Failed to load payments', pe);
            }
        } catch (err) {
            console.error('Failed to load meetings', err);
            alert.showAlert(resources.get('PatientDashboard.LoadFailed','Failed to load meetings'), 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-padding">
            <h2>{resources.get('PatientDashboard.Title','My Meetings')}</h2>
            {loading ? <div>{resources.get('PatientDashboard.Loading','Loading...')}</div> : (
                <div>
                    {meetings.length === 0 ? <div>{resources.get('PatientDashboard.NoMeetings','No meetings scheduled')}</div> : (
                        <ul>
                            {meetings.map(m => (
                                <li key={m.id} className="mb-8">
                                    <div className="meeting-item-title">{new Date(m.meetingDate).toLocaleString()}</div>
                                    <div>{m.summary}</div>
                                    <div className="mt-6">
                                        {m.isPaid ? <span className="text-green">{resources.get('PatientDashboard.Paid','Paid')}</span> : <span className="text-red">{resources.get('PatientDashboard.Unpaid','Unpaid')}</span>}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                    <h3 className="mt-12">{resources.get('PatientDashboard.PaymentsTitle','Payments')}</h3>
                    {payments.length === 0 ? <div>{resources.get('PatientDashboard.NoPayments','No payments found')}</div> : (
                        <ul>
                            {payments.map(p => (
                                <li key={p.paymentId} className="mb-6">
                                    <div>{p.amount} - {p.status}</div>
                                    <div className="small-text">{new Date(p.createdAt).toLocaleString()}</div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
};

export default PatientDashboard;
